export default __webpack_public_path__ + "static/media/T2-output.6a70704b.png";